import { Button, IconPlus16 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IStickyScrollBtn {
  isSticky: boolean;
  stickyRef?: React.Ref<HTMLDivElement>;
  action(): void;
  buttonText: string;
  isDesktop: boolean;
}

export function StickyScrollBtn({ stickyRef, isSticky, action, buttonText, isDesktop }: IStickyScrollBtn) {
  return (
    <div ref={stickyRef} data-testid="StickyScrollBtn" className={cn(styles['block'], isSticky && styles['sticky'])}>
      <div className={styles['button_wrap']}>
        <Button
          onClick={action}
          fullWidth={!isDesktop}
          beforeIcon={!isDesktop ? <IconPlus16 color="white_100" /> : undefined}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
}
